<div class="a-select">
  <div class="a-select-input-wrapper">
    <i class="a-select-trigger"></i>
    <ng-container *ngTemplateOutlet="inputTemplate!=null?inputTemplate:defaultInput;context:{$implicit:value}">
    </ng-container>
    <div class="a-select-placeholder" *ngIf="!isSelected">{{placeHolder}}</div>
  </div>
</div>

<ng-template #defaultInput let-option>
  <div class="a-select-input">{{getLabel(option)}}</div>
</ng-template>